/**
 * @mui/x-data-grid-pro v7.29.5
 *
 * @license MUI X Commercial
 * This source code is licensed under the commercial license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    LicenseInfo: true,
    useGridApiContext: true,
    useGridApiRef: true,
    useGridRootProps: true,
    GridColumnMenu: true,
    GRID_COLUMN_MENU_SLOTS: true,
    GRID_COLUMN_MENU_SLOT_PROPS: true,
    GridColumnHeaders: true
};
Object.defineProperty(exports, "GRID_COLUMN_MENU_SLOTS", {
    enumerable: true,
    get: function get() {
        return _reexports2.GRID_COLUMN_MENU_SLOTS;
    }
});
Object.defineProperty(exports, "GRID_COLUMN_MENU_SLOT_PROPS", {
    enumerable: true,
    get: function get() {
        return _reexports2.GRID_COLUMN_MENU_SLOT_PROPS;
    }
});
Object.defineProperty(exports, "GridColumnHeaders", {
    enumerable: true,
    get: function get() {
        return _GridColumnHeaders.GridColumnHeaders;
    }
});
Object.defineProperty(exports, "GridColumnMenu", {
    enumerable: true,
    get: function get() {
        return _reexports2.GridColumnMenu;
    }
});
exports.LicenseInfo = void 0;
Object.defineProperty(exports, "useGridApiContext", {
    enumerable: true,
    get: function get() {
        return _reexports.useGridApiContext;
    }
});
Object.defineProperty(exports, "useGridApiRef", {
    enumerable: true,
    get: function get() {
        return _reexports.useGridApiRef;
    }
});
Object.defineProperty(exports, "useGridRootProps", {
    enumerable: true,
    get: function get() {
        return _reexports.useGridRootProps;
    }
});
require("./typeOverloads");
var _xLicense = require("@mui/x-license");
var _components = require("@mui/x-data-grid/components");
Object.keys(_components).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _components[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _components[key];
        }
    });
});
var _constants = require("@mui/x-data-grid/constants");
Object.keys(_constants).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _constants[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _constants[key];
        }
    });
});
var _hooks = require("@mui/x-data-grid/hooks");
Object.keys(_hooks).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _hooks[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _hooks[key];
        }
    });
});
var _models = require("@mui/x-data-grid/models");
Object.keys(_models).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _models[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _models[key];
        }
    });
});
var _context = require("@mui/x-data-grid/context");
Object.keys(_context).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _context[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _context[key];
        }
    });
});
var _utils = require("@mui/x-data-grid/utils");
Object.keys(_utils).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _utils[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _utils[key];
        }
    });
});
var _colDef = require("@mui/x-data-grid/colDef");
Object.keys(_colDef).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _colDef[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _colDef[key];
        }
    });
});
var _DataGridPro = require("./DataGridPro");
Object.keys(_DataGridPro).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _DataGridPro[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _DataGridPro[key];
        }
    });
});
var _hooks2 = require("./hooks");
Object.keys(_hooks2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _hooks2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _hooks2[key];
        }
    });
});
var _models2 = require("./models");
Object.keys(_models2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _models2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _models2[key];
        }
    });
});
var _components2 = require("./components");
Object.keys(_components2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _components2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _components2[key];
        }
    });
});
var _utils2 = require("./utils");
Object.keys(_utils2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _utils2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _utils2[key];
        }
    });
});
var _reexports = require("./typeOverloads/reexports");
var _reexports2 = require("./components/reexports");
var _GridColumnHeaders = require("./components/GridColumnHeaders");
/**
 * @deprecated Use `@mui/x-license` package instead:
 * @example import { LicenseInfo } from '@mui/x-license';
 */ var LicenseInfo = /*#__PURE__*/ function(_xLicense_LicenseInfo) {
    _inherits(LicenseInfo, _xLicense_LicenseInfo);
    function LicenseInfo() {
        _class_call_check(this, LicenseInfo);
        return _call_super(this, LicenseInfo, arguments);
    }
    return LicenseInfo;
}(_xLicense.LicenseInfo);
exports.LicenseInfo = LicenseInfo;
